import { Stack, styled } from '@mui/material';

import { theme } from '@/shared/design-system';
import { forMobile } from '@/styles/responsive';

export const ControlRoot = styled(Stack)({
  flexDirection: 'column',
  gap: theme.spacing[12],
  paddingBottom: theme.spacing[16],
  borderBottom: `1px solid ${theme.colors.border.subtle}`,
});

export const ModeOptions = styled(Stack)(({ theme: muiTheme }) => ({
  flexDirection: 'row',
  gap: theme.spacing[12],
  '& > *': { flex: 1 },

  [forMobile(muiTheme)]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const TreeRows = styled(Stack)({
  flexDirection: 'column',
  gap: theme.spacing[8],
});

export const TreeRow = styled(Stack, { shouldForwardProp: (prop) => prop !== '$depth' })<{
  $depth: number;
}>(({ $depth }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing[8],
  paddingLeft: theme.spacing[24] * $depth,
}));

export const RequestPanel = styled(Stack)({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing[8],
});

export const RequestActions = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing[12],
});

export const PanelFooter = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing[12],
});
